export interface ColouredTagProps {
  className?: string;
  colour: ColouredTagColor;
  text: string;
}

export enum ColouredTagColor {
  DARK_GREEN = 'dark-green',
  GRAY = 'gray',
  GREEN = 'green',
  YELLOW = 'yellow',
}
